// extracted by mini-css-extract-plugin
module.exports = {"noResultsBoilerPlate":"Common_noResultsBoilerPlate__1r7JS"};